var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMoveAction = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4157",
    fillRule: "evenodd",
    d: "M4.166 10.833h9.888l-3.028 3.633c-.295.354-.246.88.107 1.174.354.295.88.246 1.174-.107l4.167-5c.032-.039.048-.085.072-.128.02-.035.044-.065.06-.103.037-.096.06-.197.06-.299V10v-.004c0-.101-.023-.202-.06-.298-.016-.038-.04-.068-.06-.103-.024-.043-.04-.09-.072-.129l-4.167-5c-.166-.197-.402-.3-.64-.3-.189 0-.378.064-.534.194-.353.294-.402.82-.107 1.173l3.028 3.633H4.166c-.46 0-.833.374-.833.834 0 .46.373.833.833.833",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoveAction, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/move_action.8b71b498.svg";
export { ForwardRef as ReactComponent };